import { render, staticRenderFns } from "./BatchShippingCountTable.vue?vue&type=template&id=9052e65e"
import script from "./BatchShippingCountTable.vue?vue&type=script&lang=js"
export * from "./BatchShippingCountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports